import React from 'react'
import { User } from 'firebase/auth'

type UserState = {
  data: User | undefined
  loading: boolean
}

const user: UserState = {
  data: undefined,
  loading: false,
}
const userContext = React.createContext({ user })

export { userContext }
